import React from "react";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import moment from "moment";
import { GetPolicyFileById } from "../../Service/SearchPolicy";
import Styles from "../User/User.module.scss";
import {
  Box,
  Divider,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import dayjs from "dayjs";

const ViewRenewalPolicy = (props) => {
  const navigate = useNavigate();
  const { setOpenDrawer, selectedData } = props;

  const ViewPdfFunction = () => {
    // setOpenLoader(true)
    GetPolicyFileById(selectedData?._id)
      .then((res) => {
        console.log(res.data);
        const pdfUrl = res?.data?.policyFile?.downloadURL;
        return pdfUrl;
      })
      .then((pdfUrl) => {
        console.log("url", pdfUrl);
        const blobData = base64toBlob(pdfUrl, "application/pdf");
        const blobUrl = URL.createObjectURL(blobData);
        // setOpenLoader(false)
        const pdfWindow = window.open("", "_blank");
        pdfWindow?.document?.write(
          // `<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`
          `<embed src="${blobUrl}" width="100%" height="100%" />`
        );
      });
  };

  const base64toBlob = (base64Data, contentType) => {
    contentType = contentType || "";
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  };
  return (
    <>
      <div className={Styles.MainRenderinContainer}>
        <Stack direction={"row"} alignItems={"center"}>
          <div className="breadcrumb" style={{ marginLeft: "33px" }}>
            <a
              className="text-color"
              onClick={() => {
                navigate("/dashboard");
              }}
              style={{ cursor: "pointer" }}
            >
              {"Home"}
            </a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
            <a
              className="text-color"
              onClick={() => {
                setOpenDrawer(false);
              }}
              style={{ cursor: "pointer" }}
            >
              {"User"}
            </a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
            <a className="text-color">{"AddUser"}</a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
          </div>
        </Stack>
        <>
          <div className={Styles.formContainer}>
            <Grid
              container
              className="Master_Card_Container"
              sx={{
                border: "none",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Grid
                container
                className="Master_Card_Sub_Container"
                alignItems="center"
                justifyContent="space-between"
                sx={{ display: "flex" }}
              >
                <Typography
                  className="Master_Card_Tittle"
                  sx={{ flexGrow: 1, textAlign: { xs: "center", sm: "left" } }}
                >
                  View Policy List
                </Typography>
                <CloseIcon
                  onClick={() => setOpenDrawer(false)}
                  sx={{ cursor: "pointer", ml: 2 }}
                />
              </Grid>

              <Grid item xs={12}>
                <Divider
                  sx={{
                    backgroundColor: "#EAECF0",
                    borderWidth: 1,
                  }}
                />
              </Grid>
            </Grid>

            <Box className={Styles.formContent}>
              <Box
                sx={{
                  borderBottom: "1px solid #EAECF0",
                  p: "0 15px",
                  pb: "20px",
                }}
              >
                {[
                  {
                    title: "Policy Files",
                    fields: [
                      {
                        label: "New Policy",
                        value: `${selectedData.policyNumber}. POLICYFILE`,
                      },
                      {
                        label: "Documents",
                        value: selectedData?.branchId?.branchName,
                      },
                      {
                        label: "User Name",
                        value: selectedData?.userId?.name,
                      },
                      {
                        label: "Branch",
                        value: selectedData?.branchId?.branchName,
                      },
                    ],
                  },
                  {
                    title: "Policy Details",
                    fields: [
                      {
                        label: "Issue Date",
                        value: moment(selectedData?.issueDate).format("L"),
                      },
                      {
                        label: "Company Name",
                        value: selectedData?.companyId?.companyName,
                      },
                      {
                        label: "Product",
                        value: selectedData?.productId?.product,
                      },
                      {
                        label: "Policy Type",
                        value: selectedData?.policyTypeId?.policyType,
                      },
                      {
                        label: "Booking Code",
                        value: selectedData?.bookingCodeId?.bookingCode,
                      },
                      {
                        label: "Policy Number",
                        value: selectedData?.policyNumber,
                      },
                    ],
                  },
                  {
                    title: "Customer Details",
                    fields: [
                      {
                        label: "Customer Name",
                        value: selectedData?.customerName,
                      },
                      { label: "Mobile", value: selectedData?.mobileNumber },
                      { label: "Email", value: selectedData?.email },
                    ],
                  },
                  {
                    title: "Vehicle Details",
                    fields: [
                      {
                        label: "Reg Number",
                        value: selectedData?.registrationNumber,
                      },
                      { label: "Make Model", value: selectedData?.makeModel },
                      { label: "CC", value: selectedData?.cc },
                      {
                        label: "Seating Capacity",
                        value: selectedData?.seatingCapacity,
                      },
                      { label: "GVW", value: selectedData?.gvw },
                    ],
                  },
                  {
                    title: "OD Policy Date",
                    fields: [
                      {
                        label: "User Type",
                        value: dayjs(selectedData?.issueDate).format(
                          "DD/MM/YYYY"
                        ),
                      },
                      {
                        label: "Branch",
                        value: selectedData?.branchId?.branchName,
                      },
                      {
                        label: "Branch Manager",
                        value: selectedData?.branchManager?.name,
                      },
                    ],
                  },
                  {
                    title: "TP Policy Date",
                    fields: [
                      {
                        label: "TP Policy Start Date",
                        value: dayjs(selectedData?.tpPolicyStartDate).format(
                          "L"
                        ),
                      },
                      {
                        label: "TP Policy Period",
                        value: selectedData?.tpPolicyPeriod,
                      },
                      {
                        label: "TP Policy End Date",
                        value: selectedData?.branchManager?.name,
                      },
                    ],
                  },
                  {
                    title: "Premium",
                    fields: [
                      {
                        label: "OD Disc",
                        value: selectedData?.odDisc,
                      },
                      { label: "OD Premium", value: selectedData?.odPremium },
                      { label: "TP Premium", value: selectedData?.tpPremium },
                      {
                        label: "NET Premium",
                        value: selectedData?.netPremium,
                      },
                      {
                        label: "Total Premium",
                        value: selectedData?.totalPremium,
                      },
                      { label: "PA Cover", value: selectedData?.paCover },
                    ],
                  },
                  {
                    title: "Payment Details",
                    fields: [
                      {
                        label: "Payment Mode",
                        value: selectedData?.paymentMode,
                      },
                    ],
                  },
                ].map((section, index) => (
                  <Box
                    key={index}
                    sx={{
                      borderBottom: "1px solid #EAECF0",
                      p: "0 15px",
                      pb: "20px",
                    }}
                  >
                    <Typography mt={3} className={Styles.formTitleHead}>
                      {section.title}
                    </Typography>
                    <Grid container spacing={2} mt={1}>
                      {section.fields.map((field, idx) => (
                        <Grid item xs={12} sm={6} md={3} key={idx}>
                          <Typography
                            className={Styles.inputTitle}
                            sx={{ fontSize: "12px", mb: 1 }}
                          >
                            {field.label}
                          </Typography>
                          <Typography
                            className={Styles.inputValue}
                            onClick={
                              field.label === "New Policy"
                                ? () => ViewPdfFunction()
                                : undefined
                            }
                            sx={{
                              color:
                                field.label === "New Policy"
                                  ? "blue !important"
                                  : "inherit",
                              cursor:
                                field.label === "New Policy"
                                  ? "pointer"
                                  : "default",
                            }}
                          >
                            {field.value || "--"}
                          </Typography>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                ))}
              </Box>
            </Box>
          </div>
        </>
      </div>
    </>
  );
};

export default ViewRenewalPolicy;
